import { useEffect } from "react";

/**
 * Pose le titre du document tant que le composant est monté, et rétablit le
 * précédent au démontage — le même geste que les coquilles d'espace, pour les
 * pages qui n'en ont pas (la vitrine, l'inscription).
 */
export function useDocumentTitle(titre: string): void {
  useEffect(() => {
    const avant = document.title;
    document.title = titre;
    return () => {
      document.title = avant;
    };
  }, [titre]);
}
